import { httpApi } from "./http.api";


export const gmailIntegration = (isEmailRead: boolean): Promise<any> =>
  httpApi.post<any>(`users/gmail/authorize-user/?email_read=${isEmailRead}`).then(({ data }) => data);

export const outlookIntegration = (isEmailRead: boolean): Promise<any> =>
    httpApi.post<any>(`users/outlook/authorize-user/?email_read=${isEmailRead}`).then(({ data }) => data);

export const setFireFliesAPIKey = (formData: FormData): Promise<any> =>
  httpApi.post<any>("users/fireflies/save-api-key/", formData).then(({ data }) => data);

export const getFireFliesAPIKey = () : Promise<any> =>
  httpApi.get<any>("users/fireflies/get-api-key/").then(({ data }) => data);

export const deleteFireFliesAPIKey = () : Promise<any> =>
  httpApi.delete<any>("users/fireflies/delete-api-key/").then(({ data }) => data);

export const generateExtentionKey = () : Promise<any> =>
  httpApi.get<any>(`users/user-custom/generate-extension-key/`).then(({ data }) => data);
